import './MachineTypeMap.css'

import React, { useEffect, useState } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import MapComponent, { MapRow } from '@/components/Map/Map'

import { BackButton } from '@/components/layout/NavBar'
import { MachineTypeMapComponent } from '@/components/Map/MachineTypeMap'
import { Spinner } from '@/components/spinner'
import { Roles, isAdminRole } from '@/services/repository/users'

export const MachineTypeMapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const [rows, setRows] = useState<MapRow[] | undefined>(undefined)

  useEffect(() => {
    services.session.fetchWithToken(isAdminRole(session.user.role) ? `/api/communal/map` : '/api/communal/my/map').then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        console.error(erros)
        return Promise.reject<MapRow[]>()
      }
      const respData = await r.json()
      const resp: MapRow[] = respData.rows
      setRows(resp)
    })
  }, [])

  if (!rows) {
    return <Spinner />
  }

  return <LoggedInPageLayout pageName='dashboard-machinetype-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
      
    <div className='default-map-container'>
      <MachineTypeMapComponent rows={rows} services={services} session={session} />
    </div>
  </LoggedInPageLayout>
}
